import { makeModuleStateSelector } from "@client/content/selectors";
import { globals } from "@client/globals";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type Cart } from "./types";

export const localStateSelector = makeModuleStateSelector<Cart.State>(defaultState, previewState);

export const apiUrlSelector = createSelector([], () => globals.paths.apiUrl);
